import Vue from 'vue'
import Router from 'vue-router'
import Dashboard from '@/pages/Dashboard'
import Members from '@/pages/Members'
import Configuration from '@/pages/Configuration'
import Login from '@/pages/Login'
import Organizations from '@/pages/Organizations'
import Users from '@/pages/Users'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    { path: '/', name: 'Dashboard', component: Dashboard },
    { path: '/configuration', name: 'Configuration', component: Configuration },
    { path: '/login', name: 'Login', component: Login },
    { path: '/members', name: 'Members', component: Members },
    { path: '/organizations', name: 'Organizations', component: Organizations },
    { path: '/users', name: 'Users', component: Users }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js